import { useMutation } from 'react-query';

import { type MutationFunction, useRequest } from '@frontend/api';

type BulkUpdateQuoteItemsQueryVars = {
  quoteId: number;
  quoteItems: { id: number; position: number }[];
};

export const useBulkUpdateQuoteItems: MutationFunction<
  null,
  BulkUpdateQuoteItemsQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/bulk_update_quote_items`, {
        init: {
          method: 'PATCH',
          body,
        },
      }),
    {
      ...queryOptions,
      mutationKey: ['quotes', 'quoteItems', 'bulkUpdateQuoteItems'],
    },
  );
};
